import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import DropdownList from 'react-widgets/lib/DropdownList';

const propTypes = exact({
  setBonusMonthAction: PropTypes.func.isRequired,
  allBonusMonths: PropTypes.array.isRequired,
  bonusMonth: PropTypes.string,
});


const BonusPeriod = (props) => {
  const { allBonusMonths, setBonusMonthAction, bonusMonth } = props;

  const handleBonusMonthOnChange = (bonusMonthObject) => {
    const monthValue = bonusMonthObject.iso8601;
    setBonusMonthAction(monthValue);
  };

  return (
    <DropdownList
      inputProps={{
        className: 'form-control',
      }}
      data={allBonusMonths}
      filter="contains"
      valueField="iso8601"
      textField="month_year_display"
      value={bonusMonth}
      onChange={(data) => { return handleBonusMonthOnChange(data); }}
    />
  );
};


BonusPeriod.propTypes = propTypes;


export default BonusPeriod;
